<template>
  <VModal :showing="showing" container-classes="max-w-screen-md" @update:showing="$emit('update:showing', $event)">
    <h2 class="text-xl mb-8 mr-8 truncate">Delete {{ target }}?</h2>
    <p class="text-gray-800 font-light">
      The selected {{ pluralize(slides.length, 'slide') }} will be removed permanently. This action cannot be reversed!
    </p>
    <p class="text-gray-800 font-light">Are you sure you want to continue?</p>
    <div class="flex flex-row gap-4 mt-8 w-full justify-end">
      <VButton class="w-42" data-testid="cancel-button" @click="$emit('update:showing', false)">Cancel</VButton>
      <VButton class="w-42" variant="danger" data-testid="delete-button" @click="$emit('delete-slides', slides)">Confirm</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { defineComponent, computed } from 'vue'

import type { Slide } from '@/entities/deck'

const props = defineProps({
  slides: {
    type: Array as PropType<Slide[]>,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['delete-slides', 'update:showing'])

const target = computed(() => {
  return props.slides.length === 1 ? props.slides[0].title : `${props.slides.length} Slides`
})

function pluralize(length: number, word: string): string {
  return length > 1 ? `${word}s` : word
}
</script>
